import { z } from "zod";

import { isoDate } from "./iso-date-schema";

// Enum mimics from your schema — adjust as needed
export const placeTypeEnum = z.enum(["CONDO", "HOUSE", "BUILDING", "OFFICE"]);

export const placeItemSchema = z.object({
  id: z.string().length(24),
  shortId: z.string().nullable(),
  uuid: z.string().uuid(),
  name: z.string(),
  address1: z.string(),
  address2: z.string().nullable(),
  zipcode: z.string(),
  state: z.string(),
  city: z.string(),
  estimatedValue: z.number().nullable(),
  latitude: z.string().nullable(),
  longitude: z.string().nullable(),
  isTest: z.boolean(),
  type: placeTypeEnum,
  isValid: z.boolean().nullable(),
  formattedAddress: z.string().nullable(),
  uspsAddress: z.string().nullable(),
  placeGroupId: z.string().nullable(),
  marketId: z.string().nullable(),
  createdAt: isoDate,
  updatedAt: isoDate,
  memberships: z.any().nullish(),
  userPlaces: z.any().nullish(),
});
